import { Itinerary, ItineraryDynamicType } from '../models/itinerary';
import { Authentication } from './core/baseRequest';
import { BaseGetRequest } from './core/baseGetRequest';

export class ItineraryRequest extends BaseGetRequest<Itinerary> {
    constructor(public bookingId: string) {
        super(`bookings/${bookingId}/itinerary`, {}, ItineraryDynamicType, Authentication.SharingToken, 'v2');
    }
}
